import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

function ProtectedRoute() {
  const { authStatus, user } = useAuthStore();
  const location = useLocation();
  const isForcePasswordPage = location.pathname === '/force-password-change';

  if (authStatus === 'checking') {
    return <div className="page-loading">Loading...</div>;
  }

  if (authStatus !== 'authenticated' || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user?.mustChangePassword && !isForcePasswordPage) {
    return <Navigate to="/force-password-change" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
